;(function (window, APP, _) {
	'use strict';

	var
		Collection  = APP.module('Collection'),

		CACHE = {},
		EXPIRED_SEC = 30
	;

	function getRequestedUrl(){
		var url = _.toArray(arguments)[1].url;
		return _.isFunction(url) ? url.call(this) : url;
	}

	function isCacheExpired(cache){
		var
			now = _.now(),
			old = cache.timestamp
		;

		return ((now - old) / 1000) >= EXPIRED_SEC;
	}

	function isResponseSuccess(cache){
		var resp = cache.response;
		return resp.readyState === 4 && resp.status === 200;
	}

	function fetchAndCache(){
		var
			url = getRequestedUrl.apply(this, arguments),
			request = Backbone.sync.apply(this, arguments)
		;

		CACHE[url] = {
			timestamp: _.now(),
			response: request
		};

		return request;
	}

	function updateColection(data, opts){
		var success = opts.success;

		this[opts.reset ? 'reset' : 'set'](data, opts);

		if (success){
			success.call(opts.context, data);
		}

		this.trigger('sync', this, data, opts);
	}

	var SyncRewrite = {
		sync: function() {
			var
				url = getRequestedUrl.apply(this, arguments),
				cache = CACHE[url],

				opts = _.last(_.toArray(arguments)),
				opts = _.extend({parse: true}, opts),

				resp = cache && cache.response,
				data = resp && resp.responseJSON,

				Checksum = this.checksumEmitter,

				args = [this].concat(Array.prototype.slice.apply(arguments)),
				fetchData = fetchAndCache.bind.apply(fetchAndCache, args),
				forceUpdate = _.bind(updateColection, this, data, opts)
			;

			if(!url){
				throw new Error('URL field should be defined in collection before fetch call');
			}

			// If don't have cache or request was with error
			if(_.isUndefined(cache) || !isResponseSuccess(cache)){
				return fetchData();
			}

			// If have a cache and checksumEmitter, so json will be updated only in case updating checksums
			if(Checksum){
				var defer = $.Deferred();

				Checksum.makeRequest().done(function(response){
					if(!Checksum.getChecksum()){
						Checksum.setChecksum(response);
					}

					var
						checksums = {},

						diffKeys = Checksum.getDiffKeys(response),
						key = _.first(url.split('.')),

						is_updated = Boolean(~_.indexOf(diffKeys, key))
					;

					if(is_updated){
						checksums = Checksum.getChecksum();
						checksums[key] = response[key];

						Checksum.setChecksum(checksums);

						fetchData().done(defer.resolve);
					}
					else{
						forceUpdate();

						defer.resolve(data);
					}
				});

				return defer.promise();
			}
			else if(isCacheExpired(cache)){ // If don't have checksumEmitter and cache is expired
				return fetchData();
			}

			// If request exist in cache but not complete yet
			if(cache.response.readyState !== 4){
				return cache.response;
			}

			forceUpdate();

			// Return data from cache
			return $.Deferred(function(dfr){
				dfr.resolve(data)
			}).promise();
		}
	};

	Collection.FetchCache = Backbone.Collection.extend(SyncRewrite)

})(window, APP, _);